<script lang="ts">

  import { getContext } from "svelte";
  import { ConnectMapApp } from "../app";
  import BtnControl from "../BtnControl.svelte";
  import type { ManageAPI } from "~/manage-api/types";
  import UIMessage from "../UIMessage.svelte";

  const app = getContext<ConnectMapApp<any>>('app');

  const { is_desktop, poi_selected, T } = app;

  $: poi = $poi_selected;
  $: store = poi?.type == 'store' ? poi.data as ManageAPI.Store : null;
  $: image_src = store?.images?.at(0) || store?.logoURL;
  $: routable = poi
  
</script>

<div class="poi-detail">
  {#if image_src}
    <!-- svelte-ignore a11y-missing-attribute -->
    <img src={image_src} />
  {/if}
  {#if poi}
    <strong class="poi-label">{poi.label}</strong>
    <span class="poi-floor">{poi.floor}</span>
  {/if}
  <hr />

  <div class="actions">
    {#if poi?.routable == false}
      <UIMessage type="warning">
        {$T`not_routable_poi`}
      </UIMessage>
    {:else}
      <BtnControl on:click={app.state.route} width="full">{$T`route`}</BtnControl>
      {#if !$is_desktop}
        <BtnControl on:click={app.state.showLocation} width="full">{$T`show_location`}</BtnControl>
      {/if}
    {/if}
  </div>
</div>

<style>

  img {
    display: block;
    width: clamp(180px, 90%, 220px);
    margin: var(--_p2) auto var(--_p4);
    aspect-ratio: 16/9;
    object-fit: scale-down;
  }

  .poi-detail {
    padding: var(--_p1);
  }

  .poi-label {
    display: block;
  }

  .actions {
    display: flex;
    gap: var(--_p2);
  }

  small {
    font-style: italic;
  }
</style>